import { render } from "./BannerUpdate.vue?vue&type=template&id=6190645d&scoped=true"
import script from "./BannerUpdate.vue?vue&type=script&lang=js"
export * from "./BannerUpdate.vue?vue&type=script&lang=js"

import "./BannerUpdate.vue?vue&type=style&index=0&id=6190645d&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6190645d"]])

export default __exports__